module.exports = __webpack_public_path__ + "img/laundry.3337ee9d.svg";